import { render, staticRenderFns } from "./ComplaintListTable.vue?vue&type=template&id=7857c204&scoped=true"
import script from "./ComplaintListTable.vue?vue&type=script&lang=js"
export * from "./ComplaintListTable.vue?vue&type=script&lang=js"
import style0 from "./ComplaintListTable.vue?vue&type=style&index=0&id=7857c204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7857c204",
  null
  
)

export default component.exports